import React from 'react'
import Manager from '../../public/components/Manager'
import SalaryInfoSettingDetail from './SalaryInfoSettingDetail'
Ext.require('Ext.Toast')

const config = {
    buttons: [
    ],
    columns: [
        { _text: '申请编号', minWidth: 250, search: true, },
        { _text: '生效月份', field: '_EffectiveMonth', minWidth: 150, },
        { _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
        { _datetime: '申请时间', field: 'CreateTime', minWidth: 150, filter: true, align: 'left', },
        { _text: '申请原因', minWidth: 150, flex: 10, search: true },
        { _text: '状态', field: 'StatusName', minWidth: 150, search: true, filter: ['select'], },
        { _: 'taskName', field: '_TaskName' }
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        showDetail(props => <SalaryInfoSettingDetail {...props} id={data.id} taskName={data.taskName} />)
    }
}

export default props => <Manager {...props} config={config} />